import { HTTP_STATUS_CODE } from '../common/consts';

class WorkatoModel {
  responseCode;
  token;
  errorResponse;

  constructor(options = {}) {
    this.responseCode = options.status;
    if (options.status === HTTP_STATUS_CODE.OK) {
      this.token = options.data.token;
      this.errorResponse = null;
    } else {
      this.token = null;
      this.errorResponse = options.data;
    }
  }
}

export default WorkatoModel;
